import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { DeleteOutlined, EditOutlined } from '@mui/icons-material';
import { ActivityCardView } from '../useSmartGoalDialogController';
import { tokens } from './tokens';

const iconButtonSx = { color: tokens.icon, '&:hover': { background: tokens.borderSubtle } };

/** One activity in the goal: colored accent bar, label, caller-supplied body, and edit/remove buttons. */
export const ActivityCard: React.FC<{
  card: ActivityCardView;
  label: string;
  onEdit: () => void;
  onDelete: () => void;
  children: React.ReactNode;
}> = ({ card, label, onEdit, onDelete, children }) => (
  <Box
    data-testid="smart-goal-activity-card"
    sx={{
      display: 'flex',
      flex: 'none',
      background: '#fff',
      borderRadius: '16px',
      border: `1px solid ${tokens.border}`,
      overflow: 'hidden',
      boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
    }}
  >
    <Box sx={{ width: 4, background: card.color, flexShrink: 0 }} />
    <Box sx={{ flex: 1, p: 2, display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1.5 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: '12px',
            color: tokens.label,
            textTransform: 'uppercase',
            letterSpacing: '0.15em',
            fontWeight: 600,
          }}
        >
          {label}
        </Typography>
        {children}
      </Box>
      <Box sx={{ display: 'flex', gap: 0.5, flexShrink: 0 }}>
        <IconButton size="small" aria-label={`Edit ${card.name}`} onClick={onEdit} sx={iconButtonSx}>
          <EditOutlined fontSize="small" />
        </IconButton>
        <IconButton size="small" aria-label={`Remove ${card.name}`} onClick={onDelete} sx={iconButtonSx}>
          <DeleteOutlined fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  </Box>
);
